import React from "react";
import { _t } from "../../i18n/i18n";

export const JPRiskAndFees = () => (
  <small className="text-gray">
    <p>
      <b>{_t("Fees and Risks")}</b>
      <br />
      {_t("Fees and Risks msg")}
    </p>

    <p>
      <b>{_t("Nomura Securities Co., Ltd.")}</b>
      <br />
      {_t("Instruments msg")}
      <br />
      {_t("Members msg")}
    </p>
  </small>
);
